module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.72/js/sprocket_white.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/sprocket_white.svg
// module id = 6
// module chunks = 0 1